import * as Yup from 'yup';

export const trainingInitialValues = {
  training_name: '',
  training_description: '',
  training_code: '',
  //   center: null as number | null,
  courses: [] as string[],
  id: null as number | null,
  image: [] as File[],
  is_active:true
};
const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
export const TrainingSchemaValidations = Yup.object().shape({
  training_name: Yup.string()
    .min(2, 'Too Short!')
    .max(200, 'Too Long!')
    .required('Title is required'),
  training_description: Yup.string().min(2, 'Too Short!').required('Description is required'),
  training_code: Yup.string().required('Code is required'),
  courses: Yup.array()
    .min(1, 'course  is required.')
    .required("You can't leave this blank.")
    .nullable(),
    is_active:Yup.boolean().default(true)
  // image: Yup.mixed()
  //   .required('A file is required')
  //   .nullable()
  //   .test((value) => !value || (value && value.size <= 1024 * 1024))
  //   .test(
  //     'format',
  //     'upload file',
  //     (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
  //   )
  // center: Yup.number().required('Training Center is required')
});

export interface IResourcesFormInput {
  name: string;
  training_id: string;
  resource_file: string;
  id: number;
  // is_active:boolean
}

export const ResourcesInitialValues: IResourcesFormInput = {
  name: '',
  training_id: '',
  resource_file: '',
  id: 0,
};

export const ResourcesSchemaValidation = Yup.object().shape({
  training_id: Yup.string().min(1, 'Training ID must be valid').required('Training ID is required'),

  name: Yup.string()
    .trim()
    .min(5, 'Name must be at least 5 characters long')
    .max(500, 'Question is too long')
    .required('Question title is required'),
  resource_file: Yup.string().nullable(),
  id: Yup.number().nullable()
});
